import { render, staticRenderFns } from "./ExampleManage.vue?vue&type=template&id=23cfd7eb&scoped=true&"
import script from "./ExampleManage.vue?vue&type=script&lang=js&"
export * from "./ExampleManage.vue?vue&type=script&lang=js&"
import style0 from "./ExampleManage.vue?vue&type=style&index=0&id=23cfd7eb&lang=scss&scoped=true&"
import style1 from "./ExampleManage.vue?vue&type=style&index=1&id=23cfd7eb&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cfd7eb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Jenkins_Home\\workspace\\liveinfo3-front-admin-dev\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23cfd7eb')) {
      api.createRecord('23cfd7eb', component.options)
    } else {
      api.reload('23cfd7eb', component.options)
    }
    module.hot.accept("./ExampleManage.vue?vue&type=template&id=23cfd7eb&scoped=true&", function () {
      api.rerender('23cfd7eb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/examples/example-manage/ExampleManage.vue"
export default component.exports